/**
 * Onderbalk-hoogte — ÉÉN bron van waarheid (BLOK 4). Alle afgeleide maten (balk-hoogte, sidebar-bodem-
 * offset, content padding-bottom, split-mode-hoogtes) leiden hieruit af via inline-styles, zodat er geen
 * losse h-11/bottom-11/pb-11 verspreid raken. Wijzig enkel hier om de balk hoger/lager te maken.
 */
export const ONDERBALK_HOOGTE_PX = 44
export const ONDERBALK_HOOGTE = `${ONDERBALK_HOOGTE_PX}px`

// Hoogte van een viewport-kolom minus de Topbar (4rem = h-16) minus de onderbalk — voor split/paneel-modus.
export const CONTENT_HOOGTE_CALC = `calc(100vh - 4rem - ${ONDERBALK_HOOGTE_PX}px)`
